import { render, staticRenderFns } from "./ArtistLibrary.vue?vue&type=template&id=59606114&"
import script from "./ArtistLibrary.vue?vue&type=script&lang=ts&"
export * from "./ArtistLibrary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports